import { Address, L2ChainId } from '../../types'
import { BigNumber } from 'ethers'
import { useEffect, useState } from 'react'
import { getFee } from '../../api/v1/account'
import { sdk } from '../../utils/signer/utils'
import { bn, e2w } from '../../utils/number'

export function useWithdrawFee({
  address,
  currency,
  chainId,
  fastWithdraw,
}: {
  chainId: L2ChainId
  address: Address
  currency: string
  fastWithdraw: 0 | 1
}): [BigNumber | undefined, boolean] {
  const [fee, setFee] = useState<BigNumber>()
  const [pending, setPending] = useState<boolean>(false)
  useEffect(() => {
    if (!address || !currency || !chainId) {
      return
    }
    setFee(undefined)
    setPending(true)
    getFee({
      chainId,
      op: 'Withdraw',
      address,
      currency,
    })
      .then((res) => {
        try {
          const packedFee = sdk.closestPackableTransactionFee(
            e2w(res.data).toString()
          )
          setFee(bn(packedFee))
        } catch (e) {
          console.error(e)
        }
      })
      .finally(() => {
        setPending(false)
      })
  }, [chainId, address, currency, fastWithdraw])

  return [fee, pending]
}
